import {
  IApiRequest,
  IApiResponse,
  IApiToastMessageConfig,
  ISuppressedWorkTemplateBase,
} from "@miplatform/types";
import {
  API_VERSION,
  HTTP_METHODS,
  TASK_SERVICE,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_SUPPRESSED_WORK = `${TASK_SERVICE}/suppressed-work-template-bases`;

export const suppressedWork = {
  getAll: async (
    accountId?: string,
    { filters, sort, top, skip }: IApiRequest = {}
  ): Promise<IApiResponse<ISuppressedWorkTemplateBase[]>> => {
    const options = await apiOptions({
      method: "GET",
      url: `${API_SUPPRESSED_WORK}`,
      headers: { [X_API_VERSION]: API_VERSION },
      sort,
      top,
      skip,
      filters: {
        ...(accountId && {
          accountId: {
            eq: { type: "guid", value: accountId },
          },
        }),
        ...filters,
      },
    });

    return apiRequest(options);
  },

  create: async (
    data: {
      accountId: string;
      workTemplateBaseId: string;
    },
    toastConfig: IApiToastMessageConfig
  ): IApiResponse<ISuppressedWorkTemplateBase> => {
    const options = await apiOptions({
      method: HTTP_METHODS.POST,
      url: `${API_SUPPRESSED_WORK}`,
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastConfig);
  },

  delete: async (
    id: string,
    modifiedOn: string,
    toastConfig: IApiToastMessageConfig
  ): IApiResponse<void> => {
    const options = await apiOptions({
      method: HTTP_METHODS.DELETE,
      url: `${API_SUPPRESSED_WORK}/${id}`,
      headers: { [X_API_VERSION]: API_VERSION },
      data: { modifiedOn },
    });

    return apiRequest(options, toastConfig);
  },
};
